import RelatedLazy from '../../../components/article/sidebar/relatedLazy';
export default RelatedLazy;
